import axios from "axios";

export const getCollesctionCount = async (name) => {
  const response = await axios.get(`/api/${name}`);
  return response.data.meta.pagination.total;
};
